const assetRoot = `${process.env.PUBLIC_URL || ""}/assets/stitch-menu`;

export const STITCH_DINING_IMAGE = `${assetRoot}/hero.jpg`;

// Only use a reference dish photo when the existing menu name matches it.
// Explicit menu photos always take precedence in MenuImage.
const dishImages = {
  "selat usar": "selat-usar.jpg",
  kapiratu: "kapiratu.jpg",
  "sop manten": "sop-manten.jpg",
  "gecok ganem": "gecok-ganem.jpg",
  "bakmi djawa goreng / godog": "bakmi-jawa.jpg",
  "nasi blawong": "nasi-blawong.jpg",
};

export function stitchDishImage(name) {
  const filename = dishImages[String(name || "").trim().toLowerCase()];
  return filename ? `${assetRoot}/${filename}` : "";
}
